import React, { PureComponent } from 'react';

import { showModal } from '../actions/modal';

import config from '../config';

import FileUpload from './file-upload';
import DropdownBtn from './dropdown-btn';
import GoogleFileChooser from './google-file-chooser';
import DropboxFileChooser from './dropbox-file-chooser';

import IconUpload from '../icons/icon-upload';
import IconDropbox from '../icons/icon-dropbox';
import IconGDrive from '../icons/icon-gdrive';
import IconDoc from '../icons/icon-doc';

class UploadComponent extends PureComponent {
    render() {
        const { onUpload, children } = this.props;
        return (
            <React.Fragment>
                <FileUpload
                    onUpload={onUpload}
                    projectId={this.props.projectId}
                    taskId={this.props.taskId}
                    docId={this.props.docId}
                    upload={true}
                />

                { children }
            </React.Fragment>
        )
    }
}

export default class MultiUpload extends PureComponent {
    handleInternalDocClick = () => {
        showModal('DOC_PICKER', {
            projectId: this.props.projectId,
            onSelect: this.props.onInternalDocSelect
        });
    }

    render() {
        const items = [
            {
                component: (
                    <div>
                        <UploadComponent
                            projectId={this.props.projectId}
                            taskId={this.props.taskId}
                            docId={this.props.docId}
                            onUpload={this.props.onUpload}
                        >
                            <span className="circle-icon">
                                <IconUpload />
                            </span>&nbsp;

                            Your Computer
                        </UploadComponent>
                    </div>
                )
            },
            {
                component: (
                    <GoogleFileChooser
                        projectId={this.props.projectId}
                        taskId={this.props.taskId}
                        docId={this.props.docId}
                    >
                        <span className="circle-icon">
                            <IconGDrive />
                        </span>&nbsp;

                        Google Drive
                    </GoogleFileChooser>
                )
            }
        ];

        if (config.DROPBOX.ENABLED) {
            items.push({
                component: (
                    <DropboxFileChooser
                        projectId={this.props.projectId}
                        taskId={this.props.taskId}
                        docId={this.props.docId}
                    >
                        <span className="circle-icon">
                            <IconDropbox />
                        </span>&nbsp;

                        Dropbox
                    </DropboxFileChooser>
                )
            });
        }

        if (this.props.internalDocEnabled) {
            items.push({
                component: (
                    <div className="item" onClick={this.handleInternalDocClick}>
                        <span className="circle-icon">
                            <IconDoc />
                        </span>&nbsp;

                        Nifty Docs
                    </div>
                )
            });
        }

        return (
            <div className="multi-upload">
                <DropdownBtn
                    keepVisible={true}
                    xAlign="right"
                    defaultXPosition="right"
                    title="UPLOAD FILE FROM:"
                    btnClassName={'btn ' + this.props.btnClassName}
                    dropdownClassName="multi-upload-dropdown"
                    items={items}
                >
                    { this.props.children }
                </DropdownBtn>
            </div>
        )
    }
}
